<template>
  <v-card class="text-center">
    <v-card-title v-if="cargando" class="grey lighten-4 change-font" primary-title>
      <div class="spinner-grow"></div>Cargando puntos &#8230;
    </v-card-title>
    <v-card-title v-else class="grey lighten-4 change-font" primary-title>
      {{ titulo }}
      <span class="d-none d-md-block" style="white-space: pre-wrap;">&nbsp; ({{ total }} puntos -&nbsp; </span>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span class="d-none d-md-block" style="white-space: pre-wrap;" v-on="on">{{ totalChilds }} </span>
        </template>
        <span>Para el reporte de los indicadores F.411, F.E.7, A397, A.66, A.67, A.68, AG8, AG9,  se desagregaron en diferentes entidades, ver el detalle por indicador.</span>
      </v-tooltip>
      <span class="d-none d-md-block " style="white-space: pre-wrap;">&nbsp; indicadores PMI)</span>
    </v-card-title>
    <v-card-text>
      <v-container v-if="!cargando && gpuntos.length>0" fluid grid-list-xl>
        <v-layout wrap>
          <p
            class="aclaratoria"
          >Conozca el avance en la implementación del Acuerdo Final de Paz en cada uno de los seis puntos que lo componen.</p>
          <v-flex
            style="margin-top:-55px; "
            s12
            sm6
            md4
            v-for="item of gpuntos"
            v-bind:key="item.idpunto"
          >
            <gaugesimple
              v-bind:nombre="'punto6-' + item.idpunto"
              v-bind:id="item.idpunto"
              v-bind:titulo="item.nombre"
              v-bind:subtitulo="
                '(' +
                  item.pilares +
                  ' pilares - ' +
                  item.indicadores +
                  ' indicadores)'
              "
              navegar="1"
              v-bind:avance="item.avance"
              v-bind:color="item.color"
              v-bind:fuente="fuente"
            />
          </v-flex>
          <v-flex
           class="fechacorte"
            xs12
            v-if="gfechacorte!== null"
          >Fecha actualización: {{formato(gfechacorte.fechaactualizacion)}}</v-flex>
          <v-flex
            class="fechacorte"
            xs12
            v-if="gfechacorte!== null"
          >Fecha corte: {{formato(gfechacorte.fechacorte)}}</v-flex>
        </v-layout>
				<v-layout>
					<v-flex class="pb-0">
            <div class="col text-center pt-0 pb-0 pl-0 mt-4" :hidden="BttonHidden">
              <button  type="button" class="v-btn theme--light elevation-2 v-size--xlarge primary w-600" @click="gotoTerritorializacionPDET">
                <span class="v-btn__content">Georreferenciación de los indicadores con desagregación territorial</span>
              </button>
            </div>
					</v-flex>
				</v-layout>  
              
      </v-container>
      <p v-else>{{gnodata}}</p>
      <br />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import gaugesimple from "@/components/chart/gaugesimple.vue";
import moment from "moment";
export default {
  name: "content-punto",
  components: {
    gaugesimple
  },
  data: function() {
    return {
      path: process.env.BASE_URL,
      periodoId: 0,
      fuente: "gpuntos",
      cargando: true,
      BttonHidden: true
    };
  },
  props: {
    titulo: {
      type: String,
      required: false,
      default: "Avance por punto"
    },
    subtitulo: {
      type: String,
      required: false,
      default: "Haga clic para observar los pilares respectivos"
    },
    linkPath: {
      type: String,
      required: false,
      default: "/avance/punto"
    }
  },
  beforeUpdate() {},
  updated() {},
  created() {
    this.recalcular();
  },
  mounted() {},
  computed: {
    ...mapGetters("barra", ["gperiodo"]),
    ...mapGetters(["gpuntos", "gfechacorte"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    totalChilds() {
      var t = 0;
      if (this.gpuntos !== undefined) {
        this.gpuntos.forEach(element => {
          t += element.indicadores;
        });
        return t;
      } else return 0;
    },
    totalChildsPNS() {
      var t = 0;
      if (this.gpuntos !== undefined) {
        this.gpuntos.forEach(element => {
          t += element.indicadoresPNS;
        });
        return t;
      } else return 0;
    },
    total() {
      if (this.gpuntos !== undefined) return this.gpuntos.length;
      else return 0;
    }
  },
  methods: {
    ...mapActions(["puntoTodos", "get_fechacorteglobal"]),
    recalcular() {
      this.puntoTodos({
        params: {
          periodoId: this.gperiodo
        }
      });
      this.get_fechacorteglobal({
        params: {
          idperiodo: this.gperiodo
        }
      });
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    gotoTerritorializacionPDET()
		{
			// Nota se queman los valores de Punto y clasificador
			// se llama ese formulario desde aqui con esos valores predeterminados y no va a cambiar.
			let link = "/territorial"; 
      console.log('ingreso al pdte/territorial')
      this.$router.push(link);
		},
  },
  watch: {
    gperiodo: function() {
      this.recalcular();
    },
    gpuntos: function() {
      this.cargando = false;
    }
  }
};
</script>